import * as React from "react";

import * as SpellSchoolSvgs from "../../Svg/spellSchools";
import { SpellSchoolPropType } from "../IconConstants";

type ThemeMode = "dark" | "gray" | "light";

type SpellSchoolSvgModule = typeof SpellSchoolSvgs;

type ThemedSpellSchoolSvg = SpellSchoolSvgModule["DarkAbjurationSvg"];

type SpellSchoolSvgSet = Record<
  SpellSchoolPropType,
  Record<ThemeMode, ThemedSpellSchoolSvg>
>;

const buildSvgSet = (svgs: SpellSchoolSvgModule): SpellSchoolSvgSet => ({
  abjuration: {
    dark: svgs.DarkAbjurationSvg,
    gray: svgs.GrayAbjurationSvg,
    light: svgs.LightAbjurationSvg,
  },
  conjuration: {
    dark: svgs.DarkConjurationSvg,
    gray: svgs.GrayConjurationSvg,
    light: svgs.LightConjurationSvg,
  },
  divination: {
    dark: svgs.DarkDivinationSvg,
    gray: svgs.GrayDivinationSvg,
    light: svgs.LightDivinationSvg,
  },
  enchantment: {
    dark: svgs.DarkEnchantmentSvg,
    gray: svgs.GrayEnchantmentSvg,
    light: svgs.LightEnchantmentSvg,
  },
  evocation: {
    dark: svgs.DarkEvocationSvg,
    gray: svgs.GrayEvocationSvg,
    light: svgs.LightEvocationSvg,
  },
  illusion: {
    dark: svgs.DarkIllusionSvg,
    gray: svgs.GrayIllusionSvg,
    light: svgs.LightIllusionSvg,
  },
  necromancy: {
    dark: svgs.DarkNecromancySvg,
    gray: svgs.GrayNecromancySvg,
    light: svgs.LightNecromancySvg,
  },
  transmutation: {
    dark: svgs.DarkTransmutationSvg,
    gray: svgs.GrayTransmutationSvg,
    light: svgs.LightTransmutationSvg,
  },
});

const SPELL_SCHOOL_SVGS = buildSvgSet(SpellSchoolSvgs);

interface Props {
  school: SpellSchoolPropType;
  themeMode?: ThemeMode;
  className?: string;
}

const SpellSchoolIcon: React.FunctionComponent<Props> = ({
  className = "",
  themeMode = "dark",
  school,
}) => {
  const SvgIcon = SPELL_SCHOOL_SVGS[school]?.[themeMode] ?? null;

  if (SvgIcon === null) {
    return null;
  }

  const classNames: Array<string> = [
    className,
    "ddbc-spell-school-icon",
    `ddbc-spell-school-icon--${school}`,
  ];

  return <SvgIcon className={classNames.join(" ")} />;
};

export default SpellSchoolIcon;
